import * as yup from 'yup';

import { emailValidationSchema } from 'src/constants/validation';

import { InviteFormFields } from '../types';

const employerValidationSchema = yup.object({
  email: emailValidationSchema.required('Email field is required'),
  shouldCreateBillingRules: yup.boolean().defined(),
});

export const inviteFormValidationSchema = yup.object({
  [InviteFormFields.employers]: yup
    .array()
    .of(employerValidationSchema)
    .nullable()
    .min(1, 'Field must have at least 1 item')
    .required('Required'),
});
